import React from "react";

/**
 * Small reusable shimmer block used by page-level skeleton layouts.
 *
 * Keeping the primitive in one place helps the loading shells stay visually
 * consistent across routes without repeating the gradient animation setup.
 */
export default function SkeletonBlock({
  className = "",
  tone = "default",
  "data-testid": dataTestId,
}) {
  return (
    <div
      aria-hidden="true"
      data-testid={dataTestId || "pdx-skeleton-block"}
      className={`pdx-skeleton-block ${
        tone === "light" ? "pdx-skeleton-block--light" : ""
      } ${className}`.trim()}
    />
  );
}
